<template>
    <div class="nav-container">
        <div class="web-logo">
            <router-link to="/home">
                <img style="height: 48px;width: auto;" src="../assets/icon/logo.png" alt="">
            </router-link>
        </div>
        <ul class="nav-list">
            <li class="nav-item" v-for="item in navList">
                <router-link active-class="active-link" :to="item.link">
                    <div class="link-item">{{ item.title }}</div>
                    <!-- <div class="link-item-en">{{ item.enTitle }}</div> -->
                </router-link>
                <div class="nav-sublist-wrap">
                    <ul class="nav-sublist">
                        <li class="nav-subitem" v-for="subitem in item.sublink">
                            <a v-if="subitem.type ==='else'" :href="subitem.link" target="_blank">{{ subitem.title }}</a>
                            <router-link v-else="subitem.type" :to="subitem.link">{{ subitem.title }}</router-link>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <div class="nav-right">
            <i class="phone-icon"><img src="../assets/icon/icon-phone.png" alt=""></i>
            <span class="commu-phone-text">加盟电话：</span>
            <span class="commu-phone">400-070-2717</span>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                navList:[
                    {
                        title:'首页',enTitle:'Home',link:'/home',isActive:true,
                        sublink:[
                            {title:'发展历程',link:'/home?block=fzlc'},
                            {title:'使命/价值观',link:'/home?block=smjzg'},
                            // {title:'对话创始人',link:'/home?block=dhcsr'},
                        ]
                    },
                    {
                        title:'品牌介绍',enTitle:'Brand',link:'/brand',isActive:false,
                        sublink:[
                            {title:'品牌简介',link:'/brand?block=ppjj'},
                            {title:'品牌历程',link:'/brand?block=pplc'},
                            {title:'品牌IP',link:'/brand?block=ppip'},
                            {title:'核心优势',link:'/brand?block=hxys'},
                        ]
                    },
                    {
                        title:'门店展示',enTitle:'Store',link:'/store',isActive:false,
                        sublink:[
                            {title:'门店形象',link:'/store?block=mdxx'},
                            {title:'门店全景',link:'/store?block=mdqj'},
                            {title:'门店查询',link:'/store?block=mdcx'},
                        ]
                    },
                    {
                        title:'招商加盟',enTitle:'Join',link:'/join',isActive:false,
                        sublink:[
                            {title:'合作支持',link:'/join?block=hzzc'},
                            // {title:'开放区域',link:'/join?block=kfqy'},
                            {title:'加盟流程',link:'/join?block=jmlc'},
                            // {title:'加盟费用',link:'/join?block=jmfy'},
                            // {title:'门店建议',link:'/join?block=mdjy'},
                            {title:'常见问答',link:'/join?block=cjwd'}
                        ]
                    },
                    {
                        title:'品牌资讯',enTitle:'Information',link:'/information',isActive:false,
                        sublink:[
                            // {title:'对话创始人',link:'/information?block=dhcsr'},
                            {title:'品牌动向',link:'/information?block=ppdx'},
                            {title:'新闻资讯',link:'/information?block=qyxw'},
                            {title:'加盟商故事',link:'/information?block=jmsgs'},
                        ]
                    },
                    {
                        title:'联系我们',enTitle:'Connect',link:'/connect',isActive:false,
                        sublink:[
                            {title:'关注我们',link:'/connect?block=gzwm'},
                            {title:'人才招聘',link:'https://hnlshm3.zhiye.com/',type:'else'},
                            {title:'公司地址',link:'/connect?block=gsdz'},
                            {title:'投诉建议',link:'/connect?block=tsjy'},
                        ]
                    },
                ]
            }
        }
    }
</script>
<style scoped>
@keyframes activeItemAnimate {
    0%{
        width: 0;
        opacity: 0;
        background-color: #fff;
    }100%{
        width: 100%;
        opacity: 1;
        background-color: #E60012;
    }
}
.nav-container{
    position: sticky;
    top: 0;
    left: 0;
    min-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 120px 6px;
    background-color: #fff;
    z-index: 11;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.1);
    font-family: Source Han Sans;
}
.nav-list{
    max-width: 730px;
    display: flex;
    justify-content: space-between;
    flex:1;
}
.nav-item{
    position: relative;
}
.nav-item >>> a{
    position: relative;
    display: block;
    padding: 2px 4px 15px;
    text-decoration: none;
}
.active-link .link-item,.nav-item:hover .link-item{
    color: #E60012;
}
.nav-item:hover .nav-sublist-wrap{
    display: block;
}
.active-link::before{
    content:'';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8px;
    border-radius: 4px 4px 0 0;
    background-color: #E60012;
    opacity: 1;
    animation: activeItemAnimate .2s ease;
}
.link-item{
    line-height: 24px;
    color: #000;
    font-size: 16px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
}
.link-item-en{
    font-size: 12px;
    line-height: 18px;
    color: #666;
    /* font-family: Poppins-Light, Poppins; */

    text-align: center;
    font-weight: lighter;
}
.nav-right{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.phone-icon{
    height: 24px;
}
.commu-phone-text{
    font-size: 18px;
    /* font-family: Source Han Sans CN-Bold, Source Han Sans CN; */
    font-weight: bold;
    color: #E60012;
    line-height: 21px;
}
.commu-phone{
    font-size: 18px;
    /* font-family: Poppins-Medium, Poppins; */
    font-weight: 500;
    color: #201D1D;
    line-height: 21px;
}
.nav-sublist-wrap{
    display: none;
    position: absolute;
    width: 158px;
    top: 40px;
    left: 50%;
    margin: 0 -79px;
    padding: 20px 0 ;
}
.nav-sublist{
    padding: 10px;
    background-color: rgba(255,255,255,.95);
    border: 1px solid rgba(230,0,18,0.2);
    border-radius: 20px;
    text-align: center;
}
.nav-subitem{
   
}
.nav-subitem >>> a{

    padding: 10px 5px;
    text-decoration: none;
    font-size: 16px;
    /* font-family: Source Han Sans CN-Normal, Source Han Sans CN; */
    font-family: Source Han Sans;
    font-weight: 400;
    color: #000000;
    line-height: 19px;
}
.nav-subitem:hover >>> a {
    cursor: pointer;
    background-color: #E60012;
    border-radius: 50px;
}
.nav-subitem:hover >>> a{
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/navBar.vue